import {Route} from "@angular/router";
import {Type} from "@angular/core";
import {AccessDeniedComponent} from "../../components/login/default-login/access-denied.component";
import {LoginPageComponent} from "../../components/login/default-login/login-page.component";
import {AuthGuard} from "./auth.guard";

export class AuthRouteBuilder {
    static authRoutes(accessDeniedComponent: Type<any> = AccessDeniedComponent): Route[] {
        return [
            {path: "login", component: LoginPageComponent},
            {path: "accessDenied", component: accessDeniedComponent, canActivate: [AuthGuard]}
        ];
    }
}
